(function () {
    'use strict';

    angular.module("imApp").factory("discGrpCustsService", [function () {
        let service = {};

        return service;
    }]);
})();
